import { useState } from "react";
import { Box, Button, CircularProgress, IconButton, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"
import { styles } from "./styles"
import alertBlue from '../../assets/image/blueAlertEmoji.svg';
import { useApi } from "hooks/useApis";
import { AxiosError } from "axios";

export const ModalDeleteConditionality = ({
  isOpen = false,
  handleClose,
  conditionalityId
}) => {

  const api = useApi()
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const LoadingIcon = () => {
    if (isLoading) {
      return <CircularProgress size={20} sx={{ color: 'white' }} />
    }
    return null;
  }

  const deleteConditionality = async () => {
    setIsLoading(true);
    try {
      await api.deleteConditionality(conditionalityId)

      setErrorMsg(null);
      window.location.reload();
    } catch (err) {
      if (err instanceof AxiosError) {
        setErrorMsg(err.response.data['detail'])
      }
    }
    finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal
      open={isOpen}
      close={handleClose}
      sx={styles.modal}
    >
      <Box sx={styles.mainBox}>
        <IconButton aria-label="Fechar" sx={styles.closeButton} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        <Box sx={styles.header}>
          <img src={alertBlue} alt='Emoji de alerta azul' style={styles.emoji} />
          <Typography sx={styles.title}>Tem certeza que deseja excluir o acompanhamento?</Typography>
        </Box>
        <Box sx={styles.body}>
          <Typography sx={styles.justificationText}>
            Ao prosseguir, este acompanhamento será apagado de forma definitiva
            e não poderá ser recuperado.
          </Typography>
          <Box sx={styles.footer}>
            <Button
              sx={styles.buttonNo}
              onClick={handleClose}
              disabled={isLoading}
            >
              Não
            </Button>
            <Button
              sx={styles.buttonConfirm}
              onClick={deleteConditionality}
              disabled={isLoading}
              endIcon={<LoadingIcon />}
            >
              Sim
            </Button>
          </Box>
          {
            errorMsg &&
            <Typography sx={styles.errorMessage}>
              {errorMsg}
            </Typography>
          }
        </Box>
      </Box>
    </Modal>
  );
}
